import color from '../../../res/color';
import values from '../../../res/values';

export default {
    main: {
        height: 'auto',
        width: '20%',
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        userSelect: "none",
        backgroundColor: color.transparent,
        top: 10,
        left: 0,
        right: 0,
        margin: 'auto',
        justifyContent: 'space-around',
    },
    border: {
        height: 20,
        width: '100%',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto'
    },
    title: {
        height: 40,
        width: '50%',
        color: color.whiteFontColor,
        fontSize: values.fontMediumLarge,
        backgroundColor: color.transparent,
        textAlign: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto'
    }
}